// extracted by mini-css-extract-plugin
module.exports = {"title":"step_title__282Xp","content":"step_content__hzUwI","logoSvg":"step_logoSvg__1k9-q","text":"step_text__vq2rh","skipStep":"step_skipStep__30XBc"};